var ItemView = (function (BaseView, GlobalSettings) {
	return BaseView.extend({
		className: 'clearfix list-row',

		events: {
			'click @increase': 'increase',
			'click @decrease': 'decrease',
            'click @delete': 'delete'
		},

		initialize: function () {
			_.bindAll(this, 'render', 'remove', '_spinStop', '_spinStart');

			this.listenTo(this.model, 'change', this.render);
			this.listenTo(this.model, 'remove', this.remove);

			this.spinner = new Spinner(smallSpinnerConfig);
		},

		render: function () {
			this.$el.html($.tmpl('bt-checkout-item', $.extend(this.model.toJSON(), {
				ImgUrl: this.model.getImageUrl(),
				ProductLink: this.model.getProductLink(),
				PriceStr: window.toMoney(this.model.get('Price')),
				SubtotalStr: window.toMoney(this.model.get('Subtotal'))
			})));
			this.$increase = this.$('@increase');
			this.$decrease = this.$('@decrease');
			return this;
		},

		increase: function (e) {
			if (this._disableButtons) return;
			this._spinStart(e.currentTarget);
			this.model.increase().always(this._spinStop);
		},

        decrease: function (e) {
            if (this._disableButtons) return;
            this._spinStart(e.currentTarget);
            this.model.decrease().always(this._spinStop);
		},

        delete: function (e) {
			if (this._disableButtons) return;
			this.disableButtons = true;
			this.$el.addClass('opacity-block');
			var _this = this;

			var pixel = this.options.removeFromCartPixel;
			pixel && pixel.trigger(_.extend(this.model.toJSON(), {Currency: GlobalSettings.Currency}));

			this.model.delete().always(function () {
                _this.disableButtons = false;
            });
        },

		_spinStart: function (button) {
			this._disableButtons = true;
			this.spinner.spin(button.parentNode);
			this.$pressedButton = $(button).hide();
		},

		_spinStop: function () {
			this.spinner.stop();
			this.$pressedButton.show();
			this._disableButtons = false;
		}
	});
})(BaseView, GlobalSettings);
